{
  "blocks": [
    {
      "id": "med-estradiol-oral",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "pre-cycle",
        "fet",
        "ivf",
        "evidence-based"
      ],
      "title": "Estrace",
      "subtitle": "Estradiol oral tablets for endometrial preparation",
      "body": {
        "genericName": "Estradiol (oral)",
        "drugClass": "Estrogen",
        "purpose": "Used in some protocols to help prepare the uterine lining for embryo transfer in frozen embryo transfer (FET) cycles. Whether it is appropriate, and how it is combined with monitoring or other treatment, depends on the person's protocol and clinic plan.",
        "commonRoutes": ["oral"],
        "commonForms": ["pill"],
        "dosageRanges": "There is no universal FET dose. The prescribed route, dose, timing, and duration come from the clinic's order and may differ by product and protocol.",
        "howToTake": "Use estradiol only as prescribed, using the route, dose, timing, and duration on your clinic's order or pharmacy label. Do not start, stop, switch routes, or change the dose from this article. Ask your clinic or pharmacist what to do if a dose is late or missed, and keep the monitoring appointments that are part of your plan.",
        "sideEffects": [
          "Headache",
          "Nausea",
          "Breast tenderness and swelling",
          "Bloating and water retention",
          "Mood changes",
          "Spotting or breakthrough bleeding",
          "Fatigue",
          "Increased risk of blood clots (low with short-term use)"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Protect from light and moisture.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Estrace"]
          },
          {
            "country": "UK",
            "brands": ["Progynova", "Elleste Solo"]
          },
          {
            "country": "EU",
            "brands": ["Progynova", "Provames", "Estrofem"]
          },
          {
            "country": "AU",
            "brands": ["Progynova", "Estrofem"]
          },
          {
            "country": "FR",
            "brands": ["Provames", "Oromone", "Estrofem"],
            "cisByBrand": {
              "Provames": "65421374",
              "Oromone": "60071379"
            }
          }
        ],
        "availability": [
          {
            "name": "Estrace",
            "manufacturer": "AbbVie",
            "countries": ["US"]
          },
          {
            "name": "Estrofem",
            "manufacturer": "Novo Nordisk",
            "countries": ["AU", "NZ", "DK", "ZA", "HK", "PH"]
          },
          {
            "name": "Climaval",
            "manufacturer": "Sandoz",
            "countries": ["GB"]
          },
          {
            "name": "Progynova",
            "manufacturer": "Bayer",
            "countries": [
              "GB",
              "AU",
              "NZ",
              "DE",
              "IT",
              "ES",
              "FR",
              "NL",
              "IN",
              "MY",
              "TH"
            ]
          }
        ],
        "aliases": [
          "Provames",
          "Oromone",
          "Estradiol",
          "Œstrogène",
          "Estrogen"
        ],
        "forWhom": "her",
        "frBody": {
          "genericName": "Estradiol (oral)",
          "drugClass": "Œstrogène",
          "purpose": "Utilisé dans certains protocoles pour préparer la muqueuse utérine au transfert d'embryon dans les cycles de transfert d'embryon congelé (TEC). Son indication, son association au suivi et les autres traitements dépendent du protocole et du plan du centre.",
          "dosageRanges": "Il n'existe pas de dose universelle pour un TEC. La voie, la dose, le calendrier et la durée prescrits viennent de l'ordonnance du centre et peuvent varier selon le produit et le protocole.",
          "howToTake": "Utilisez l'estradiol uniquement selon l'ordonnance, avec la voie, la dose, le calendrier et la durée indiqués par votre centre ou la pharmacie. Ne commencez pas, n'arrêtez pas, ne changez pas de voie et ne modifiez pas la dose à partir de cet article. Demandez au centre ou au pharmacien quoi faire en cas de dose retardée ou oubliée, et respectez les contrôles prévus.",
          "sideEffects": [
            "Maux de tête",
            "Nausées",
            "Sensibilité et gonflement des seins",
            "Ballonnements et rétention d'eau",
            "Changements d'humeur",
            "Spotting ou saignements intermenstruels",
            "Fatigue",
            "Augmentation du risque de caillots (faible en cure courte)"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). À protéger de la lumière et de l'humidité."
        }
      }
    },
    {
      "id": "med-estradiol-patches",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "pre-cycle",
        "fet",
        "evidence-based"
      ],
      "title": "Climara",
      "subtitle": "Estradiol transdermal patches for endometrial preparation",
      "body": {
        "genericName": "Estradiol (transdermal patch)",
        "drugClass": "Estrogen",
        "purpose": "Delivers estradiol through the skin for endometrial preparation in FET cycles. Transdermal patches bypass the liver (first-pass metabolism), which may reduce the risk of blood clots compared to oral estradiol and can provide more stable estrogen levels. Often used as an alternative to oral estradiol for patients who experience significant nausea or who are at higher clotting risk.",
        "commonRoutes": ["topical"],
        "commonForms": ["patch"],
        "dosageRanges": "There is no universal FET dose for an estradiol patch. The prescribed patch strength, number of patches, change interval, and duration come from the clinic's order and product labeling.",
        "howToTake": "Use the patch only as prescribed and follow the product label and your clinic's placement instructions. Do not start, stop, add, remove, or change patches based on this article. Ask your clinic or pharmacist what to do if a patch loosens, falls off, or a change is late; keep the monitoring appointments that are part of your plan.",
        "sideEffects": [
          "Skin irritation or redness at patch site",
          "Headache",
          "Breast tenderness",
          "Nausea (less than oral route)",
          "Bloating",
          "Mood changes",
          "Patch adhesion issues (especially in hot weather)"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Keep in the sealed pouch until ready to use. Do not refrigerate or freeze.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Climara", "Vivelle-Dot", "Minivelle"]
          },
          {
            "country": "UK",
            "brands": ["Estradot", "Evorel"]
          },
          {
            "country": "EU",
            "brands": ["Climara", "Estradot", "Evorel"]
          },
          {
            "country": "AU",
            "brands": ["Climara", "Estradot", "Evopad"]
          },
          {
            "country": "FR",
            "brands": [
              "Vivelledot",
              "Climara",
              "Estrapatch",
              "Femsept",
              "Oesclim"
            ],
            "cisByBrand": {
              "Femsept": "67144004"
            }
          }
        ],
        "availability": [
          {
            "name": "Climara",
            "manufacturer": "Bayer",
            "countries": ["US", "CA", "DE"]
          },
          {
            "name": "Vivelle-Dot",
            "manufacturer": "Novartis",
            "countries": ["US", "CA"]
          },
          {
            "name": "Estradot",
            "manufacturer": "Sandoz",
            "countries": ["AU", "NZ", "CA"]
          },
          {
            "name": "Estraderm",
            "manufacturer": "Novartis",
            "countries": ["GB", "AU", "CH"]
          },
          {
            "name": "Estraderm MX",
            "manufacturer": "Novartis",
            "countries": ["GB", "IN"]
          },
          {
            "name": "Evorel",
            "manufacturer": "Theramex",
            "countries": ["GB"]
          }
        ],
        "aliases": ["Évorel", "Femsept", "Patch estradiol", "Estradiol patch"],
        "forWhom": "her",
        "frBody": {
          "genericName": "Estradiol (patch transdermique)",
          "drugClass": "Œstrogène",
          "purpose": "Délivre l'estradiol à travers la peau pour préparer l'endomètre dans les cycles de TEC (transfert d'embryon congelé). Les patchs transdermiques contournent le foie (premier passage hépatique), ce qui peut réduire le risque de caillots par rapport à l'estradiol oral et offrir des taux d'œstrogènes plus stables. Souvent utilisé en alternative à l'estradiol oral chez les patientes qui présentent des nausées importantes ou un risque thromboembolique plus élevé.",
          "dosageRanges": "Il n'existe pas de dose universelle de patch d'estradiol pour un TEC. Le dosage, le nombre de patchs, l'intervalle de changement et la durée prescrits figurent sur l'ordonnance du centre et la notice du produit.",
          "howToTake": "Utilisez le patch uniquement selon l'ordonnance et suivez la notice ainsi que les consignes de pose de votre centre. Ne commencez pas, n'arrêtez pas, n'ajoutez pas, ne retirez pas et ne modifiez pas les patchs à partir de cet article. Demandez au centre ou au pharmacien quoi faire si un patch se décolle, tombe ou si un changement est en retard ; respectez les contrôles prévus.",
          "sideEffects": [
            "Irritation ou rougeur cutanée au site du patch",
            "Maux de tête",
            "Sensibilité des seins",
            "Nausées (moins qu'avec la voie orale)",
            "Ballonnements",
            "Changements d'humeur",
            "Problèmes d'adhérence du patch (surtout par temps chaud)"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). Gardez dans le sachet scellé jusqu'à utilisation. Ne pas réfrigérer ni congeler."
        }
      }
    },
    {
      "id": "med-estradiol-valerate",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "ivf",
        "fet",
        "evidence-based"
      ],
      "title": "Delestrogen",
      "subtitle": "Estradiol valerate injection for estrogen supplementation",
      "body": {
        "genericName": "Estradiol valerate (injection)",
        "drugClass": "Estrogen",
        "purpose": "An injectable form of estradiol used when higher or more precise estrogen levels are needed during FET or IVF cycles. Intramuscular injection provides consistent estrogen delivery and is sometimes prescribed when oral or transdermal routes do not achieve adequate endometrial thickness or estrogen levels.",
        "commonRoutes": ["intramuscular"],
        "commonForms": ["vial"],
        "dosageRanges": "There is no universal FET dose for injectable estradiol. The prescribed strength, injection schedule, and duration are set by the clinic from the order and product labeling.",
        "howToTake": "Injectable estradiol should be used only after your clinic or pharmacist has given you product-specific administration instructions. Do not self-inject, change the dose or schedule, or substitute a product based on this article. Ask your care team what to do about a late or missed injection and report concerning injection-site or allergic symptoms promptly.",
        "sideEffects": [
          "Injection site pain and soreness",
          "Headache",
          "Breast tenderness",
          "Nausea",
          "Bloating and water retention",
          "Mood changes",
          "Injection site lumps (from oil carrier)"
        ],
        "storage": "Store at room temperature (20-25°C / 68-77°F). Protect from light. Do not refrigerate.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Delestrogen"]
          },
          {
            "country": "UK",
            "brands": ["Progynon Depot"]
          },
          {
            "country": "EU",
            "brands": ["Progynon Depot", "Neofollin"]
          },
          {
            "country": "AU",
            "brands": ["Progynon Depot"]
          },
          {
            "country": "FR",
            "brands": ["Estradiol Aguettant"]
          }
        ],
        "availability": [
          {
            "name": "Delestrogen",
            "manufacturer": "Par Pharmaceutical",
            "countries": ["US"]
          },
          {
            "name": "Progynon Depot",
            "manufacturer": "Bayer",
            "countries": ["DE"]
          },
          {
            "name": "Neofollin",
            "manufacturer": "Biotika",
            "countries": ["CZ"]
          },
          {
            "name": "Estrabet",
            "manufacturer": "Sun Pharma",
            "countries": ["IN"]
          }
        ],
        "aliases": [
          "Estradiol valerate",
          "Valérate d'estradiol",
          "Progynon Depot"
        ],
        "forWhom": "her",
        "frBody": {
          "genericName": "Valérate d'estradiol (injection)",
          "drugClass": "Œstrogène",
          "purpose": "Forme injectable d'estradiol utilisée lorsque des taux d'œstrogènes plus élevés ou plus précis sont nécessaires en TEC (transfert d'embryon congelé) ou en FIV (fécondation in vitro). L'injection intramusculaire assure une libération régulière et est parfois prescrite lorsque la voie orale ou transdermique ne permet pas d'atteindre une épaisseur endométriale ou des taux d'œstrogènes suffisants.",
          "dosageRanges": "Il n'existe pas de dose universelle de valérate d'estradiol injectable pour un TEC. Le dosage, le calendrier des injections et la durée sont fixés par le centre selon l'ordonnance et la notice du produit.",
          "howToTake": "Le valérate d'estradiol injectable doit être utilisé uniquement après les consignes d'administration propres au produit données par votre centre ou votre pharmacien. Ne vous injectez pas le produit, ne modifiez pas la dose ou le calendrier et ne remplacez pas un produit à partir de cet article. Demandez à votre équipe quoi faire en cas d'injection retardée ou oubliée et signalez rapidement toute réaction préoccupante au point d'injection ou tout signe allergique.",
          "sideEffects": [
            "Douleur et sensibilité au point d'injection",
            "Maux de tête",
            "Sensibilité des seins",
            "Nausées",
            "Ballonnements et rétention d'eau",
            "Changements d'humeur",
            "Nodules au point d'injection (liés à l'excipient huileux)"
          ],
          "storage": "Conservez à température ambiante (20-25 °C). À protéger de la lumière. Ne pas réfrigérer."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
